/*
NOTE:AXIOS http://www.axios-js.com/zh-cn/docs/
NOTE:消息提示 https://2x.antdv.com/components/notification-cn
 */
import axios from 'axios'
import { notification, Modal } from 'ant-design-vue'
import { getToken, TokenKey, removeToken } from '@/utils/auth'
import store from '@/store'
import Cookies from 'js-cookie'
import { computed } from 'vue'
import { apiErrorWhitelist, silentErrorApis } from '@/utils/apiWhitelist'
const whiteList = '/health-doctor-assistant/doctor-assistant/hospital/clearCacheAndLogin'
const TcccStatus = computed(() => store.state.tccc.tcccStatus)

// import router from '@/router'
// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
  withCredentials: true, // send cookies when cross-domain requests
  timeout: 60 * 1000 // request timeout
})
// request interceptor
service.interceptors.request.use(
  config => {
    // do something before request is sent
    if (store.getters.token) {
      // config.headers['X-Token'] = getToken()
      config.headers[TokenKey] = getToken()
    }
    return config
  },
  error => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response

   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {
    const { config } = response
    const serverVersion = response.headers['Env'] || response.headers['env'] // 获取响应头中的版本标记 兼容浏览器大小写
    const clientVersion = Cookies.get('env') // 获取本地存储的客户端版本号
    console.log(
      '【服务端响应头env】',
      serverVersion || 'default',
      '【本地存储env】',
      clientVersion || 'default'
    )
    if (!config?.url.includes(whiteList)) {
      //必须获取到 env才执行
      if (
        serverVersion &&
        serverVersion !== clientVersion &&
        (!TcccStatus.value || TcccStatus.value === 'RingOff')
      ) {
        console.log('版本不一致执行reload', serverVersion, clientVersion)
        Cookies.set('env', serverVersion, { expires: 1 })
        // 如果版本不一致
        window.location.reload(true) // 刷新网页，以加载对应版本的前端资源
      }
      //服务端没返回env,但是本地cookie缓存了，清除缓存并重载
      if (
        !serverVersion &&
        clientVersion &&
        (!TcccStatus.value || TcccStatus.value === 'RingOff')
      ) {
        console.log(
          '服务端没有返回且本地有存储env,清除缓存执行reload',
          serverVersion,
          clientVersion
        )
        Cookies.remove('env')
        window.location.reload(true)
      }
    }
    const { msg = '系统异常', code = '', data, message } = response.data || {}
    //兼容老接口返回Number类型的code
    const stringCode = code.toString()
    if (stringCode !== '0' && stringCode !== '200') {
      // 强制登出
      if (stringCode === '2') return (window.location.href = '/login')
      if (stringCode === '1') {
        Modal.error({
          title: () => '账号登录状态已失效',
          content: () => '账号登录状态已失效，请重新登录!',
          onOk() {
            removeToken()
            window.location.reload()
          }
        })
      } else {
        // 添加接口自定义处理白名单
        const errApis = apiErrorWhitelist[stringCode] || []
        const { config = {} } = response
        // 后台静默接口：不弹全局通知，仍 reject 交由调用方自行处理
        const isSilent = config && config.url && silentErrorApis.includes(config.url)
        const isWhite = config && config.url && errApis.includes(config.url)
        if (isWhite) {
          return { code: stringCode, msg }
        } else if (!isSilent) {
          notification.error({
            message: message || msg,
            duration: 5
          })
        }
      }
      return Promise.reject(msg || 'error')
    } else {
      return data
    }
  },
  error => {
    // NOTE:接口报错的日志打印
    console.log('接口请求错误err' + error)
    // 后台静默接口的网络错误同样不弹全局通知，由调用方自行处理
    if (!(error?.config?.url && silentErrorApis.includes(error.config.url))) {
      notification.error({
        message: '网络错误',
        description: error.message
      })
    }
    return Promise.reject(error)
  }
)

export default service
